import { listConstants } from "../../../../NRP/constants/listConstant";
import { LocalStorageService } from "../../../../services";

const initialState = {};

export default function leaderboard(state = initialState, action) {
  switch (action.type) {
    case listConstants.LIST_CAMPAGIN_DATA_REQUEST:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };

    case listConstants.LIST_CAMPAGIN_DATA_SUCCESS:
      return {
        ...state,
        campaginData: action.payload.campaginData,
        isLoading: action.payload.isLoading,
        defaultAllColumn: action.payload.defaultAllColumn,
        totalAssessments: action.payload.totalAssessments,
        customHeaders: action.payload.customHeaders,
      };

    case listConstants.LIST_CAMPAGIN_DATA_FAILURE:
      return {
        ...state,
        message: action.payload.error,
        isLoading: action.payload.isLoading,
      };

    case listConstants.LIST_CUSTOM_HEADERS_NAMES_SUCCESS:
      return {
        ...state,
        customHeaders: action.payload.headers,
      };

    case listConstants.LIST_CUSTOM_HEADERS_NAMES_ERROR:
      return {
        ...state,
        customHeaders: [],
      };

    case listConstants.LIST_CAMPAIGN_TAGS_SUCCESS:
      return {
        ...state,
        tagsList: action.payload.tagsList,
      };
    // Toolbar
    default:
      return {
        campaign: LocalStorageService.getObject("campaign")[0],
        campaginData:null

      };
  }
}
